/**
 * 匿名访客 ID。
 *
 * 正常情况：首次访问生成随机 UUID，保存到 localStorage，后续稳定复用。
 * 旧版本已经生成的 vis_ 指纹 ID 会继续保留，避免老用户突然丢失会话。
 */

export const VISITOR_STORAGE_KEY = 'ct_vid';

export interface VisitorIdentity {
  id: string;
  /** 本次是否从 localStorage 读取到了已有 ID */
  hadStoredId: boolean;
}

function createRandomVisitorId(): string {
  return `vis_${crypto.randomUUID()}`;
}

export function saveVisitorId(id: string): void {
  try {
    localStorage.setItem(VISITOR_STORAGE_KEY, id);
  } catch {
    // 隐私模式或浏览器策略可能禁止写入，当前页面仍可继续使用
  }
}

export function getStoredVisitorId(): string | null {
  try {
    const value = localStorage.getItem(VISITOR_STORAGE_KEY);
    // 只接受随机 UUID 版本；旧版 vis_ 指纹 ID 会被视为过期并重新生成。
    return value && /^vis_[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
      ? value
      : null;
  } catch {
    return null;
  }
}

export function getVisitorIdentity(): VisitorIdentity {
  const stored = getStoredVisitorId();
  if (stored) return { id: stored, hadStoredId: true };
  // 先生成但暂不写入，后端若通过 IP 恢复旧访客，会返回真正应保存的 ID
  return { id: createRandomVisitorId(), hadStoredId: false };
}
